import { createContext, type ReactNode, useContext, useRef } from 'react';

/**
 * Refs the id of the most-recently-dragged tab for a brief window so that the
 * synthetic click browsers fire after mouseup can be ignored by that tab's
 * NavLink (without affecting any other clicks in the document, e.g. outside-
 * click handlers that should still close the popover).
 */
export type JustDraggedRef = React.MutableRefObject<string | null>;

const JustDraggedContext = createContext<JustDraggedRef | null>(null);

export const JustDraggedProvider = ({
  value,
  children,
}: {
  value: JustDraggedRef;
  children: ReactNode;
}) => (
  <JustDraggedContext.Provider value={value}>
    {children}
  </JustDraggedContext.Provider>
);

export const useJustDraggedRef = (): JustDraggedRef => {
  const fallback = useRef<string | null>(null);
  return useContext(JustDraggedContext) ?? fallback;
};
